import { render, staticRenderFns } from "./DispatcherTable.vue?vue&type=template&id=78f07338&scoped=true&"
import script from "./DispatcherTable.vue?vue&type=script&lang=js&"
export * from "./DispatcherTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherTable.vue?vue&type=style&index=0&id=78f07338&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f07338",
  null
  
)

export default component.exports